import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//create api
export const createWarranty = async (payload) => {
  try {
    const response = await api.post(`${API_BASE_URL}api/warranties/create-warrenty`, payload, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": localStorage.getItem("lang") || "en",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to create warranty" };
  }
};

// get api
export const getAllWarranties = async () => {
  try {
    const response = await api.get(`${API_BASE_URL}api/warranties`, {
      headers: {
        "Accept-Language": localStorage.getItem("lang") || "en",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to fetch warranties" };
  }
};

// updateWarranty.js
export const updateWarranty = async (id, payload) => {
  try {
    const response = await api.put(`${API_BASE_URL}api/warranties/${id}`, payload, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": localStorage.getItem("lang") || "en",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to update warranty" };
  }
};

//delete api
export const deleteWarranty = async (id) => {
  try {
    const response = await api.delete(`${API_BASE_URL}api/warranties/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": localStorage.getItem("lang") || "en",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Failed to delete warranty" };
  }
};

